import i from "../../decimal.js-light/decimal.js";
import { memoize as I, reverse as b, range as g, compose as N, map as k } from "./util/utils.js";
import y from "./util/arithmetic.js";
function p(e) {
  return D(e) || j(e) || _(e) || F();
}
function F() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function j(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
}
function D(e) {
  if (Array.isArray(e)) return w(e);
}
function v(e, t) {
  return C(e) || R(e, t) || _(e, t) || O();
}
function O() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _(e, t) {
  if (e) {
    if (typeof e == "string") return w(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return w(e, t);
  }
}
function w(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++)
    n[r] = e[r];
  return n;
}
function R(e, t) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var r = [], n = !0, a = !1, o = void 0;
    try {
      for (var u = e[Symbol.iterator](), f; !(n = (f = u.next()).done) && (r.push(f.value), !(t && r.length === t)); n = !0)
        ;
    } catch (l) {
      a = !0, o = l;
    } finally {
      try {
        !n && u.return != null && u.return();
      } finally {
        if (a) throw o;
      }
    }
    return r;
  }
}
function C(e) {
  if (Array.isArray(e)) return e;
}
function S(e) {
  var t = v(e, 2), r = t[0], n = t[1], a = r, o = n;
  return r > n && (a = n, o = r), [a, o];
}
function A(e, t, r) {
  if (e.lte(0))
    return new i(0);
  var n = y.getDigitCount(e.toNumber()), a = new i(10).pow(n), o = e.div(a), u = n !== 1 ? 0.05 : 0.1, f = new i(Math.ceil(o.div(u).toNumber())).add(r).mul(u), l = f.mul(a);
  return t ? l : new i(Math.ceil(l));
}
function E(e, t, r) {
  var n = 1, a = new i(e);
  if (!a.isint() && r) {
    var o = Math.abs(e);
    o < 1 ? (n = new i(10).pow(y.getDigitCount(e) - 1), a = new i(Math.floor(a.div(n).toNumber())).mul(n)) : o > 1 && (a = new i(Math.floor(e)));
  } else e === 0 ? a = new i(Math.floor((t - 1) / 2)) : r || (a = new i(Math.floor(e)));
  var u = Math.floor((t - 1) / 2), f = N(k(function(l) {
    return a.add(new i(l - u).mul(n)).toNumber();
  }), g);
  return f(0, t);
}
function T(e, t, r, n) {
  var a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  if (!Number.isFinite((t - e) / (r - 1)))
    return {
      step: new i(0),
      tickMin: new i(0),
      tickMax: new i(0)
    };
  var o = A(new i(t).sub(e).div(r - 1), n, a), u;
  e <= 0 && t >= 0 ? u = new i(0) : (u = new i(e).add(t).div(2), u = u.sub(new i(u).mod(o)));
  var f = Math.ceil(u.sub(e).div(o).toNumber()), l = Math.ceil(new i(t).sub(u).div(o).toNumber()), c = f + l + 1;
  return c > r ? T(e, t, r, n, a + 1) : (c < r && (l = t > 0 ? l + (r - c) : l, f = t > 0 ? f : f + (r - c)), {
    step: o,
    tickMin: u.sub(new i(f).mul(o)),
    tickMax: u.add(new i(l).mul(o))
  });
}
function H(e) {
  var t = v(e, 2), r = t[0], n = t[1], a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, u = Math.max(a, 2), f = S([r, n]), l = v(f, 2), c = l[0], m = l[1];
  if (c === -1 / 0 || m === 1 / 0) {
    var s = m === 1 / 0 ? [c].concat(p(g(0, a - 1).map(function() {
      return 1 / 0;
    }))) : [].concat(p(g(0, a - 1).map(function() {
      return -1 / 0;
    })), [m]);
    return r > n ? b(s) : s;
  }
  if (c === m)
    return E(c, a, o);
  var d = T(c, m, u, o), h = d.step, x = d.tickMin, V = d.tickMax, M = y.rangeStep(x, V.add(new i(0.1).mul(h)), h);
  return r > n ? b(M) : M;
}
function W(e, t) {
  var r = v(e, 2), n = r[0], a = r[1], o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, u = S([n, a]), f = v(u, 2), l = f[0], c = f[1];
  if (l === -1 / 0 || c === 1 / 0)
    return [n, a];
  if (l === c)
    return [l];
  var m = Math.max(t, 2), s = A(new i(c).sub(l).div(m - 1), o, 0), d = [].concat(p(y.rangeStep(new i(l), new i(c).sub(new i(0.99).mul(s)), s)), [c]);
  return n > a ? b(d) : d;
}
var $ = I(H), q = I(W);
export {
  $ as getNiceTickValues,
  q as getTickValuesFixedDomain
};
